<template>
  <div v-if="templates">
    <div class="d-flex align-items-center mb-2">
      <b-select @change="changeTemplate()"
                class="pt-0 flex-fill"
                size="sm"
                :options="templates"
                v-model="template"/>
      <!-- rewrite what was typed so it reads well; Revert puts it back -->
      <b-button-group size="sm" class="ml-2 text-nowrap">
        <b-button variant="outline-primary" :disabled="!(content || '').trim()" @click="polish"
                  v-b-tooltip.hover title="Fix grammar, tone and flow - the meaning stays the same">
          <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" class="mr-1"/>Polish
        </b-button>
        <b-button v-if="beforePolish !== null" variant="outline-secondary" @click="revert"
                  v-b-tooltip.hover title="Back to what you typed">
          <font-awesome-icon :icon="['fas', 'rotate-left']" class="mr-1"/>Revert
        </b-button>
      </b-button-group>
    </div>

    <b-textarea size="sm" ref="content" v-model="content" hide-details class="pb-4" :rows="rows"
                placeholder="Message" @input="typed"/>
  </div>
</template>

<script>
export default {
  name: "message-content-input",
  props: {
    message: Object,
    init: {
      default() {
        return {}
      },
      type: Object
    },
    rows: {
      default: 8,
      type: Number
    },
    reference: Object
  },

  data() {
    return {
      content: null,
      template: null,
      prev_template: null,

      templates: null,
      beforePolish: null,   // the text as it was before Polish; null once there is nothing to revert to
    }
  },

  watch: {
    content(v) {
      this.$emit('content', v)
    },
    template(v, p) {
      this.prev_template = p
      this.$emit('template', v)
    }
  },

  async created() {
    this.content = this.init.content

    let url = '/api/message/template'
    if (typeof this.reference === 'object' && Object.keys(this.reference).length == 1) {
      const ref_type = Object.keys(this.reference)[0]
      if (ref_type == 'order') {
        if (this.reference[this.ref_type]) {
          try {
            const ref_url = this.reference[ref_type]
            const ref = await this.asyncAction(ref_url, 'GET')
            url = ref._links.templates_url.href
          } catch (e) {
            this.alert('Failed to load reference message template,  using default')
          }
        } else if (this.$store.state.record.type === this.ref_type) {
          this.ref_url = this.$store.state.record.active._links.self_url.href
          this.ref = this.$store.state.record.active
        } else {
          this.ref = null
        }
      }
    } else if (this.message) {
      url = this.message._links.templates_url.href
    }

    this.templates = await this.asyncAction(url, 'GET')
    this.templates = this.templates.map(t => {
      return {text: t.name, value: {id: t.id, link: t._links.self_url}, content: t.content}
    })
    this.templates.unshift({text: '---- None ----', value: {id: null, link: null}})

    if (this.init.template || this.init.template === null) {
      const search = this.templates.find(f => f.value.id == this.init.template)
      if (search) {
        this.template = search.value
      }
    } else if (!this.init.template) {
      this.templates.forEach(t => {
        if (t.content) {
          this.template = t.value
          this.content = t.content
          this.setTemplate()
        }
      })
    }
  },

  methods: {
    typed() {
      this.beforePolish = null
      this.$emit('typed')
    },

    async polish() {
      const before = this.content
      const r = await this.asyncAction('/api/message/polish', 'POST', {
        data: {content: before, parent_id: this.message && this.message.id},
      })

      // typed over while it was working: keep what they typed
      if (this.content !== before)
        return

      this.beforePolish = before
      this.content = r.content
    },

    revert() {
      this.content = this.beforePolish
      this.beforePolish = null
    },

    async changeTemplate() {
      this.beforePolish = null
      this.$refs.content.$refs.input.focus()

      if (this.content)
        if (!await this.confirm('Erase content and load new template?', {scrollToPreviousElement: false})) {
          this.template = this.prev_template
          return
        }

      this.$nextTick(async () => {
        if (this.template.link) {
          const t = await this.asyncAction(this.template.link.href, this.template.link.method)
          this.content = t.content
          this.setTemplate()
        } else {
          this.content = ''
          this.setTemplate()
        }
      })
    },

    // Replace the text from outside (e.g. the AI reply); the template no longer describes it.
    setContent(text) {
      this.beforePolish = null
      if (this.templates)
        this.template = this.templates[0].value
      this.content = text
      this.$nextTick(() => this.$refs.content && this.$refs.content.focus())
    },

    setTemplate() {
      const index = this.content.indexOf('!!cursor!!')
      this.content = (this.content.replace('!!cursor!!', ''))

      if (index != -1) {
        this.$nextTick(() => {
          const el = this.$refs.content.$refs.input
          if (el.selectionStart != null) {
            el.focus();
            el.setSelectionRange(index, index - 2);
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>